import { render } from "./VAvatar.vue?vue&type=template&id=1578ce30&scoped=true"
import script from "./VAvatar.vue?vue&type=script&lang=js"
export * from "./VAvatar.vue?vue&type=script&lang=js"

import "./VAvatar.vue?vue&type=style&index=0&id=1578ce30&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1578ce30"]])

export default __exports__